// this code was borrowed from : https://stackoverflow.com/questions/22483214/regex-check-if-input-still-has-chances-to-become-matching/41580048#41580048

export const toPartialMatch = (regex: RegExp): RegExp => {
  const source = regex.source
  let currentIndex = 0

  function process() {
    let result = ''
    let tmp

    function appendRaw(nbChars: number) {
      result += source.substr(currentIndex, nbChars)
      currentIndex += nbChars
    }

    function appendOptional(nbChars: number) {
      result += '(?:' + source.substr(currentIndex, nbChars) + '|$)'
      currentIndex += nbChars
    }

    while (currentIndex < source.length) {
      switch (source[currentIndex]) {
        case '\\':
          switch (source[currentIndex + 1]) {
            case 'c':
              appendOptional(3)
              break

            case 'x':
              appendOptional(4)
              break

            case 'u':
              if (regex.unicode) {
                if (source[currentIndex + 2] === '{') {
                  appendOptional(source.indexOf('}', currentIndex) - currentIndex + 1)
                } else {
                  appendOptional(6)
                }
              } else {
                appendOptional(2)
              }
              break

            case 'p':
            case 'P':
              if (regex.unicode) {
                appendOptional(source.indexOf('}', currentIndex) - currentIndex + 1)
              } else {
                appendOptional(2)
              }
              break

            case 'k':
              appendOptional(source.indexOf('>', currentIndex) - currentIndex + 1)
              break

            default:
              appendOptional(2)
              break
          }
          break

        case '[':
          tmp = /\[(?:\\.|.)*?\]/g
          tmp.lastIndex = currentIndex
          tmp = tmp.exec(source)
          appendOptional(tmp?.[0]?.length ?? 0)
          break

        case '|':
        case '^':
        case '$':
        case '*':
        case '+':
        case '?':
          appendRaw(1)
          break

        case '{':
          tmp = /\{\d+,?\d*\}/g
          tmp.lastIndex = currentIndex
          tmp = tmp.exec(source)
          if (tmp) {
            appendRaw(tmp[0].length)
          } else {
            appendOptional(1)
          }
          break

        case '(':
          if (source[currentIndex + 1] == '?') {
            switch (source[currentIndex + 2]) {
              case ':':
                result += '(?:'
                currentIndex += 3
                result += process() + '|$)'
                break

              case '=':
                result += '(?='
                currentIndex += 3
                result += process() + ')'
                break

              case '!':
                tmp = currentIndex
                currentIndex += 3
                process()
                result += source.substr(tmp, currentIndex - tmp)
                break

              case '<':
                switch (source[currentIndex + 3]) {
                  case '=':
                  case '!':
                    tmp = currentIndex
                    currentIndex += 4
                    process()
                    result += source.substr(tmp, currentIndex - tmp)
                    break

                  default:
                    appendRaw(source.indexOf('>', currentIndex) - currentIndex + 1)
                    result += process() + '|$)'
                    break
                }
                break
            }
          } else {
            appendRaw(1)
            result += process() + '|$)'
          }
          break

        case ')':
          ++currentIndex
          return result

        default:
          appendOptional(1)
          break
      }
    }

    return result
  }

  return new RegExp(process(), regex.flags)
}
